module.exports = __webpack_public_path__ + "static/assets/c5600e9ffeae7bc6d3a71cab6c7667e5.png";